import { useState, useEffect } from "react"

export const useIsMac = () => {
  const [isMac, setIsMac] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    // Use conditional because platform is deprecated
    setIsMac((navigator?.platform.toUpperCase()?.indexOf("MAC") ?? -1) >= 0)
  }, [])

  return isMac
}
